import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/covid',
    meta: {
        title: 'The effects of COVID-19 | Child Poverty',
    },
    title: 'The effects of COVID-19',
    intro: oneLine`2020 is a year like no other. COVID-19 has impacted on almost every part of the lives of all tamariki.`,
    content: [
        oneLine`<p>While most impacts do not yet show up in the Monitor’s data, we can already see some effects in 
            job losses and reductions in whānau income.</p>`,
        oneLine`<p>Tamariki have also told us how they have been affected – sometimes in positive ways,
            like being able to spend more time with their whānau.</p>`,
        oneLine`<p>Treasury predicts that child poverty and hardship levels will rise as a result of COVID-19.
            But that depends on how the government, business and community responds.</p>`,
        oneLine`<p>Just as we came together to keep each other safe from COVID-19, it is possible to
            redesign our systems to solve poverty and ensure all tamariki have what they need to
            flourish.</p>`,
    ],
};

export default data;
